<script setup>
import InputError from "@/Components/InputError.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";

import { defineProps, ref, computed, watch, inject } from "vue";
import Swal from "sweetalert2";
import { router, useForm } from "@inertiajs/vue3";
const route = inject('route');
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  akreditasi: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["update:isOpen"]);

const form = useForm({
  id: null,
  jenis_id: 1,
  akreditasi_id: "",
  instrumen: "",
});

// Close modal
const closeModal = () => {
  emit("update:isOpen", false); // Emit event untuk menutup modal
};

// Handle click outside modal
const handleClickOutside = (event) => {
  if (event.target === event.currentTarget) {
    closeModal();
  }
};

const submit = () => {
  const routeName = form.id
    ? "instrumenkinerja.update"
    : "instrumenkinerja.store";
  form[form.id ? "put" : "post"](route(routeName, form.id || {}), {
    onSuccess: () => {
      Swal.fire({
        title: "Berhasil!",
        text: `Data berhasil ${form.id ? "diperbarui" : "disimpan"}.`,
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        form.reset();
        router.get(route("instrumenkinerja.index"));
        closeModal();
      });
    },
    onError: () => {
      Swal.fire("Error!", "Data gagal disimpan!", "error");
    },
  });
};
</script>
<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-start justify-center pt-10 bg-black bg-opacity-50"
    @click="handleClickOutside"
  >
    <div class="relative w-1/2 h-auto p-6 overflow-y-auto bg-white rounded-lg">
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-xl font-bold">{{ title }}</h2>
        <button
          type="button"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="closeModal"
          class="text-gray-500 transition duration-150 hover:text-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <form class="space-y-6" @submit.prevent="submit">
        <div>
          <input
            type="text"
            class="w-full p-3 text-sm border-gray-200 rounded-lg"
            v-model="form.id"
            hidden
          />
          <div class="mb-4">
            <label
              for="programstudi"
              class="block text-sm font-medium text-gray-700"
              >Program Studi</label
            >
            <select
              v-model="form.akreditasi_id"
              class="block w-full px-3 py-2 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
            >
              <option value="">Pilih Akreditasi</option>
              <option
                v-for="prod in akreditasi"
                :key="prod.id"
                :value="prod.id"
              >
                {{ prod.akreditasi }}
              </option>
            </select>
            <InputError :message="form.errors.jenis_dok" class="mt-2" />
          </div>

          <label class="sr-only" for="Judul">Nama</label>
          <textarea
            class="w-full p-3 text-sm border-gray-200 rounded-lg"
            placeholder="Nama Dokumen"
            rows="8"
            v-model="form.instrumen"
          ></textarea>
          <InputError :message="form.errors.instrumen" />
        </div>

        <div class="mt-4">
          <PrimaryBtn>
            <i class="fa-solid fa-floppy-disk"></i> SIMPAN
          </PrimaryBtn>
        </div>
      </form>
    </div>
  </div>
</template>
